import { sortTasks, type TaskRecord } from './types';

export function formatTask(task: TaskRecord): string {
  const lines = [
    `Task #${task.id}`,
    `Status: ${task.status}`,
    `Subject: ${task.subject}`,
    `Description: ${task.description}`,
  ];

  if (task.activeForm) {
    lines.push(`Active form: ${task.activeForm}`);
  }
  if (task.blocks.length > 0) {
    lines.push(`Blocks: ${formatTaskReferences(task.blocks)}`);
  }
  if (task.blockedBy.length > 0) {
    lines.push(`Blocked by: ${formatTaskReferences(task.blockedBy)}`);
  }
  if (task.metadata && Object.keys(task.metadata).length > 0) {
    lines.push(`Metadata: ${JSON.stringify(task.metadata)}`);
  }

  return lines.join('\n');
}

export function formatTaskList(tasks: TaskRecord[]): string {
  if (tasks.length === 0) {
    return 'No tasks in the current task list.';
  }

  const byId = new Map(tasks.map((task) => [task.id, task]));
  return sortTasks(tasks)
    .map((task) => {
      const parts = [`#${task.id}`, `[${task.status}]`, task.subject];
      const activeBlockers = task.blockedBy.filter((id) => {
        const blocker = byId.get(id);
        return !blocker || blocker.status !== 'completed';
      });
      if (activeBlockers.length > 0) {
        parts.push(`[blocked by ${formatTaskReferences(activeBlockers)}]`);
      }
      return parts.join(' ');
    })
    .join('\n');
}

export function formatTaskReferences(taskIds: string[]): string {
  return taskIds.map((id) => `#${id}`).join(', ');
}
